import CookiePolicy from "./CookiePolicy";
export default CookiePolicy;
